import { createTimeline } from 'animejs';

export function switchTitle(fromIndex, toIndex) {
    const fromTitle = document.querySelector(`[data-slide="${fromIndex}"]`);
    const toTitle = document.querySelector(`[data-slide="${toIndex}"]`);

    if (!fromTitle || !toTitle) return;

    const fromChildren = fromTitle.querySelectorAll('.banner-title > div, .banner-title > span');
    const toChildren = toTitle.querySelectorAll('.banner-title > div, .banner-title > span');

    const fromDesc = fromTitle.querySelector('.banner-desc');
    const toDesc = toTitle.querySelector('.banner-desc');

    // Проверка разрешения экрана (640px = sm breakpoint в Tailwind)
    const isMobile = window.innerWidth < 640;

    // Подготовка нового слайда
    toTitle.style.opacity = '1';
    if (toDesc) toDesc.style.opacity = 0;

    // Для desktop (sm и выше) - простая смена opacity без анимации
    if (!isMobile) {
        fromTitle.classList.remove('active');
        fromTitle.style.opacity = '0';
        if (fromDesc) fromDesc.style.opacity = 0;

        toTitle.classList.add('active');
        if (toDesc) toDesc.style.opacity = 1;

        return;
    }

    // Для mobile - полная анимация
    const tl = createTimeline({
        defaults: {
            duration: 600,
            ease: 'inOutQuad'
        },
        onComplete: () => {
            fromTitle.classList.remove('active');
            fromTitle.style.opacity = '0';
            if (fromDesc) fromDesc.style.opacity = 0;

            toTitle.classList.add('active');
            if (toDesc) toDesc.style.opacity = 1;
        }
    });

    // Анимация ухода старого заголовка
    fromChildren.forEach((el, i) => {
        tl.add(el, {
            x: i === 0 ? '-5%' : '5%',
            opacity: 0
        }, 0);
    });

    // Анимация появления нового заголовка
    toChildren.forEach((el, i) => {
        tl.add(el, {
            x: [i === 0 ? '-5%' : '5%', '0%'],
            opacity: [0, 1]
        }, 0);
    });

    // Скрытие старого описания
    if (fromDesc) {
        tl.add(fromDesc, {
            opacity: 0
        }, 0);
    }

    // Появление нового описания
    if (toDesc) {
        tl.add(toDesc, {
            opacity: 1
        }, 0);
    }
}

